import * as yup from 'yup';
import { eWeekdays } from '../../types/userProfile/IUserProfile';

// Validation for work schedule - detects invalid time entries
const validateWorkSchedule = (workSchedule: any) => {
  if (!workSchedule) return undefined;
  
  // Check for invalid time values (incomplete entries with underscores from mask)
  for (const day of Object.values(eWeekdays)) {
    const schedule = workSchedule[day];
    if (schedule) {
      if (schedule.startTime && schedule.startTime.indexOf('_') !== -1) {
        return `Invalid time format in ${day} start time. Please complete the time entry.`;
      }
      if (schedule.endTime && schedule.endTime.indexOf('_') !== -1) {
        return `Invalid time format in ${day} end time. Please complete the time entry.`;
      }
    }
  }
  
  return undefined;
};

const testEmailFormat = (value: string | null | undefined, canEditExternalEmail: boolean): boolean => {
  if (!canEditExternalEmail) return true;
  if (!value || value.trim() === '') {
    return true; // Allow null/blank values
  }
  const trimmedValue = value.trim();
  return yup.string().email().isValidSync(trimmedValue);
};

const testEmailSpaces = (value: string | null | undefined, canEditExternalEmail: boolean): boolean => {
  if (!canEditExternalEmail) return true;
  if (!value) return true;
  return value.indexOf(' ') === -1;
};

const validateExternalEmail = (canEditExternalEmail: boolean) => {
  return yup
    .string()
    .nullable()
    .test(
      'is-valid-email',
      'Please enter a valid email address',
      function (value) {
        return testEmailFormat(value, canEditExternalEmail);
      }
    )
    .test(
      'no-spaces',
      'Email address cannot contain spaces',
      function (value) {
        return testEmailSpaces(value, canEditExternalEmail);
      }
    );
};

export const editProfilePageForm = (canEditExternalEmail: boolean = false) => {
  return yup.object({
    pronouns: yup.string().nullable(),
    phoneExtension: yup.string().length(3, 'Phone extension must be 3 characters.').nullable(),
    timeZone: yup.string().nullable(),
    notes: yup.string().nullable(),
    workSchedule: yup.mixed().test(
      'time-format-validation',
      'Work schedule has invalid time formats',
      function (value) {
        const errorMessage = validateWorkSchedule(value);
        if (errorMessage) {
          return this.createError({
            message: errorMessage,
            path: 'workSchedule',
          });
        }
        return true;
      }
    ),
    externalEmail: validateExternalEmail(canEditExternalEmail),
  });
};
